package com.macrofocus.eflux

enum class Docking {
    Drawer,
    Docking,

    /**
     * UI elements (buttons, panels, search bars) are layered on top of the main content rather than occupying separate panes.
     */
    Overlay
}